import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ServiceHero = ({ service }) => {
  return (
    <div className="bg-gradient-to-br from-primary/5 to-accent/5 border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Service Information */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-primary/10 text-primary">
                <Icon name="Tag" size={14} className="mr-1" />
                {service?.category}
              </span>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-success/10 text-success">
                <Icon name="CheckCircle" size={14} className="mr-1" />
                Available
              </span>
            </div>

            <div>
              <h1 className="text-4xl font-bold text-foreground mb-4">
                {service?.title}
              </h1>
              <p className="text-lg text-muted-foreground leading-relaxed">
                {service?.overview}
              </p>
            </div>

            {/* Key Benefits */}
            <div className="space-y-3">
              <h3 className="text-lg font-semibold text-foreground">Key Benefits</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {service?.keyBenefits?.map((benefit, index) => (
                  <div key={index} className="flex items-center space-x-2">
                    <Icon name="Check" size={16} className="text-success flex-shrink-0" />
                    <span className="text-sm text-foreground">{benefit}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Link to="/rfq-request-form" state={{ serviceId: service?.id, serviceTitle: service?.title }}>
                <Button variant="default" size="lg" iconName="FileText" iconPosition="left" fullWidth className="sm:w-auto">
                  Request Quote
                </Button>
              </Link>
              <Button variant="outline" size="lg" iconName="Download" iconPosition="left" fullWidth className="sm:w-auto">
                Download Brochure
              </Button>
            </div>

            {/* Quick Stats */}
            <div className="grid grid-cols-3 gap-6 pt-6 border-t border-border">
              <div className="text-center">
                <div className="text-2xl font-bold text-primary">{service?.stats?.implementations}</div>
                <div className="text-sm text-muted-foreground">Implementations</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-primary">{service?.stats?.avgDelivery}</div>
                <div className="text-sm text-muted-foreground">Avg. Delivery</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-primary">{service?.stats?.satisfaction}</div>
                <div className="text-sm text-muted-foreground">Satisfaction</div>
              </div>
            </div>
          </div>

          {/* Service Image/Gallery */}
          <div className="relative">
            <div className="aspect-video rounded-xl overflow-hidden shadow-elevated">
              <Image
                src={service?.heroImage}
                alt={service?.title}
                className="w-full h-full object-cover"
              />
            </div>
            
            {/* Image Gallery Thumbnails */}
            <div className="flex space-x-2 mt-4 overflow-x-auto">
              {service?.gallery?.map((image, index) => (
                <div key={index} className="flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2 border-transparent hover:border-primary cursor-pointer transition-smooth">
                  <Image
                    src={image}
                    alt={`${service?.title} view ${index + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceHero;